var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "system"
  }, [_c("el-form", {
    ref: "form",
    staticClass: "system",
    attrs: {
      model: _vm.config,
      "label-width": "200px"
    }
  }, [_c("h2", [_vm._v("系统配置")]), _c("el-form-item", {
    attrs: {
      label: "环境值"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.system.env,
      callback: function callback($$v) {
        _vm.$set(_vm.config.system, "env", $$v);
      },
      expression: "config.system.env"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Oss类型"
    }
  }, [_c("el-select", {
    model: {
      value: _vm.config.system.ossType,
      callback: function callback($$v) {
        _vm.$set(_vm.config.system, "ossType", $$v);
      },
      expression: "config.system.ossType"
    }
  }, [_c("el-option", {
    attrs: {
      value: "local"
    }
  }), _c("el-option", {
    attrs: {
      value: "qiniu"
    }
  }), _c("el-option", {
    attrs: {
      value: "minio"
    }
  }), _c("el-option", {
    attrs: {
      value: "aliyun"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "错误发送邮箱"
    }
  }, [_c("el-checkbox", {
    model: {
      value: _vm.config.system.errorToEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.config.system, "errorToEmail", $$v);
      },
      expression: "config.system.errorToEmail"
    }
  }, [_vm._v("开启")])], 1), _c("el-form-item", {
    attrs: {
      label: "多点登录拦截"
    }
  }, [_c("el-checkbox", {
    model: {
      value: _vm.config.system.useMultipoint,
      callback: function callback($$v) {
        _vm.$set(_vm.config.system, "useMultipoint", $$v);
      },
      expression: "config.system.useMultipoint"
    }
  }, [_vm._v("开启")])], 1), _c("h2", [_vm._v("jwt签名")]), _c("el-form-item", {
    attrs: {
      label: "jwt签名"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.jwt.expiresAt,
      callback: function callback($$v) {
        _vm.$set(_vm.config.jwt, "expiresAt", _vm._n($$v));
      },
      expression: "config.jwt.expiresAt"
    }
  }), _c("el-input", {
    model: {
      value: _vm.config.jwt.refreshAt,
      callback: function callback($$v) {
        _vm.$set(_vm.config.jwt, "refreshAt", _vm._n($$v));
      },
      expression: "config.jwt.refreshAt"
    }
  }), _c("el-input", {
    model: {
      value: _vm.config.jwt.signingKey,
      callback: function callback($$v) {
        _vm.$set(_vm.config.jwt, "signingKey", $$v);
      },
      expression: "config.jwt.signingKey"
    }
  })], 1), _c("h2", [_vm._v("Redis admin数据库配置")]), _c("el-form-item", {
    attrs: {
      label: "db"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.redis.db,
      callback: function callback($$v) {
        _vm.$set(_vm.config.redis, "db", $$v);
      },
      expression: "config.redis.db"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "address"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.redis.address,
      callback: function callback($$v) {
        _vm.$set(_vm.config.redis, "address", $$v);
      },
      expression: "config.redis.address"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "password"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.redis.password,
      callback: function callback($$v) {
        _vm.$set(_vm.config.redis, "password", $$v);
      },
      expression: "config.redis.password"
    }
  })], 1), _c("h2", [_vm._v("邮箱配置")]), _c("el-form-item", {
    attrs: {
      label: "接收者邮箱"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "可多个，以逗号分隔"
    },
    model: {
      value: _vm.config.email.to,
      callback: function callback($$v) {
        _vm.$set(_vm.config.email, "to", $$v);
      },
      expression: "config.email.to"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "端口"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.email.port,
      callback: function callback($$v) {
        _vm.$set(_vm.config.email, "port", _vm._n($$v));
      },
      expression: "config.email.port"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "发送者邮箱"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.email.from,
      callback: function callback($$v) {
        _vm.$set(_vm.config.email, "from", $$v);
      },
      expression: "config.email.from"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "host"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.email.host,
      callback: function callback($$v) {
        _vm.$set(_vm.config.email, "host", $$v);
      },
      expression: "config.email.host"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "是否为ssl"
    }
  }, [_c("el-checkbox", {
    model: {
      value: _vm.config.email.isSSL,
      callback: function callback($$v) {
        _vm.$set(_vm.config.email, "isSSL", $$v);
      },
      expression: "config.email.isSSL"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "secret"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.email.secret,
      callback: function callback($$v) {
        _vm.$set(_vm.config.email, "secret", $$v);
      },
      expression: "config.email.secret"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "测试邮件"
    }
  }, [_c("el-button", {
    on: {
      click: _vm.email
    }
  }, [_vm._v("测试邮件")])], 1), _c("h2", [_vm._v("casbin配置")]), _c("el-form-item", {
    attrs: {
      label: "模型地址"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.casbin.modelPath,
      callback: function callback($$v) {
        _vm.$set(_vm.config.casbin, "modelPath", $$v);
      },
      expression: "config.casbin.modelPath"
    }
  })], 1), _c("h2", [_vm._v("验证码配置")]), _c("el-form-item", {
    attrs: {
      label: "keyLong"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.captcha.keyLong,
      callback: function callback($$v) {
        _vm.$set(_vm.config.captcha, "keyLong", _vm._n($$v));
      },
      expression: "config.captcha.keyLong"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "imageWidth"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.captcha.imageWidth,
      callback: function callback($$v) {
        _vm.$set(_vm.config.captcha, "imageWidth", _vm._n($$v));
      },
      expression: "config.captcha.imageWidth"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "imageHeight"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.captcha.imageHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.config.captcha, "imageHeight", _vm._n($$v));
      },
      expression: "config.captcha.imageHeight"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "验证码存在redis"
    }
  }, [_c("el-checkbox", {
    model: {
      value: _vm.config.system.captchaInRedis,
      callback: function callback($$v) {
        _vm.$set(_vm.config.system, "captchaInRedis", $$v);
      },
      expression: "config.system.captchaInRedis"
    }
  }, [_vm._v("开启")])], 1), _vm.config.system.ossType == "local" ? [_c("h2", [_vm._v("本地上传配置")]), _c("el-form-item", {
    attrs: {
      label: "本地文件路径"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.local.path,
      callback: function callback($$v) {
        _vm.$set(_vm.config.local, "path", $$v);
      },
      expression: "config.local.path"
    }
  })], 1)] : _vm._e(), _vm.config.system.ossType == "qiniu" ? [_c("h2", [_vm._v("qiniu上传配置")]), _c("el-form-item", {
    attrs: {
      label: "存储区域"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.qiniu.zone,
      callback: function callback($$v) {
        _vm.$set(_vm.config.qiniu, "zone", $$v);
      },
      expression: "config.qiniu.zone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "空间名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.qiniu.bucket,
      callback: function callback($$v) {
        _vm.$set(_vm.config.qiniu, "bucket", $$v);
      },
      expression: "config.qiniu.bucket"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "CDN加速域名"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.qiniu.imgPath,
      callback: function callback($$v) {
        _vm.$set(_vm.config.qiniu, "imgPath", $$v);
      },
      expression: "config.qiniu.imgPath"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "是否使用https"
    }
  }, [_c("el-checkbox", {
    model: {
      value: _vm.config.qiniu.useHttps,
      callback: function callback($$v) {
        _vm.$set(_vm.config.qiniu, "useHttps", $$v);
      },
      expression: "config.qiniu.useHttps"
    }
  }, [_vm._v("开启")])], 1), _c("el-form-item", {
    attrs: {
      label: "accessKey"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.qiniu.accessKey,
      callback: function callback($$v) {
        _vm.$set(_vm.config.qiniu, "accessKey", $$v);
      },
      expression: "config.qiniu.accessKey"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "secretKey"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.qiniu.secretKey,
      callback: function callback($$v) {
        _vm.$set(_vm.config.qiniu, "secretKey", $$v);
      },
      expression: "config.qiniu.secretKey"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "上传是否使用CDN上传加速"
    }
  }, [_c("el-checkbox", {
    model: {
      value: _vm.config.qiniu.useCdnDomains,
      callback: function callback($$v) {
        _vm.$set(_vm.config.qiniu, "useCdnDomains", $$v);
      },
      expression: "config.qiniu.useCdnDomains"
    }
  }, [_vm._v("开启")])], 1)] : _vm._e(), _vm.config.system.ossType == "minio" ? [_c("h2", [_vm._v("minio上传配置")]), _c("el-form-item", {
    attrs: {
      label: "存储区域"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.minio.id,
      callback: function callback($$v) {
        _vm.$set(_vm.config.minio, "id", $$v);
      },
      expression: "config.minio.id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "path"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.minio.path,
      callback: function callback($$v) {
        _vm.$set(_vm.config.minio, "path", $$v);
      },
      expression: "config.minio.path"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "token"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.minio.token,
      callback: function callback($$v) {
        _vm.$set(_vm.config.minio, "token", $$v);
      },
      expression: "config.minio.token"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "空间名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.minio.bucket,
      callback: function callback($$v) {
        _vm.$set(_vm.config.minio, "bucket", $$v);
      },
      expression: "config.minio.bucket"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "上传是否使用Ssl"
    }
  }, [_c("el-checkbox", {
    model: {
      value: _vm.config.minio.useSsl,
      callback: function callback($$v) {
        _vm.$set(_vm.config.minio, "useSsl", $$v);
      },
      expression: "config.minio.useSsl"
    }
  }, [_vm._v("开启")])], 1), _c("el-form-item", {
    attrs: {
      label: "secret"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.minio.secret,
      callback: function callback($$v) {
        _vm.$set(_vm.config.minio, "secret", $$v);
      },
      expression: "config.minio.secret"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "endpoint"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.minio.endpoint,
      callback: function callback($$v) {
        _vm.$set(_vm.config.minio, "endpoint", $$v);
      },
      expression: "config.minio.endpoint"
    }
  })], 1)] : _vm._e(), _vm.config.system.ossType == "aliyun" ? [_c("h2", [_vm._v("aliyun上传配置")]), _c("el-form-item", {
    attrs: {
      label: "path"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.aliyun.path,
      callback: function callback($$v) {
        _vm.$set(_vm.config.aliyun, "path", $$v);
      },
      expression: "config.aliyun.path"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "空间名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.aliyun.bucket,
      callback: function callback($$v) {
        _vm.$set(_vm.config.aliyun, "bucket", $$v);
      },
      expression: "config.aliyun.bucket"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "acl-type"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.aliyun.aclType,
      callback: function callback($$v) {
        _vm.$set(_vm.config.aliyun, "aclType", $$v);
      },
      expression: "config.aliyun.aclType"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "endpoint"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.aliyun.endpoint,
      callback: function callback($$v) {
        _vm.$set(_vm.config.aliyun, "endpoint", $$v);
      },
      expression: "config.aliyun.endpoint"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "access-key-id"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.aliyun.accessKeyId,
      callback: function callback($$v) {
        _vm.$set(_vm.config.aliyun, "accessKeyId", $$v);
      },
      expression: "config.aliyun.accessKeyId"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "secret-access-key"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.aliyun.secretAccessKey,
      callback: function callback($$v) {
        _vm.$set(_vm.config.aliyun, "secretAccessKey", $$v);
      },
      expression: "config.aliyun.secretAccessKey"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "storage-class-type"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.aliyun.storageClassType,
      callback: function callback($$v) {
        _vm.$set(_vm.config.aliyun, "storageClassType", $$v);
      },
      expression: "config.aliyun.storageClassType"
    }
  })], 1)] : _vm._e(), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.update
    }
  }, [_vm._v("立即更新")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.reload
    }
  }, [_vm._v("重启服务（开发中）")])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };